import { Button, Card, Col, Form, Input, Row, Select, Space, Typography } from "antd";
import { InfoCircleOutlined, PercentageOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import React from "react";
import SectionCard from "./SectionCard";

const { Text, Link, Title, Paragraph } = Typography;
export default function PricingAndRate({
  setHasModified,
  setData,
  setActivePage,
  hasModifed,
  activePage,
  data,
  template,
}) {
  const [form, useWatch] = Form.useForm();
  function onFinish(_data) {
    setData({ ...data, ..._data });
    setActivePage(activePage + 1);
  }
  function onFinishFailed() {}
  function goBack() {
    setActivePage(activePage - 1);
  }
  function handleValuesChange() {
    setHasModified && setHasModified([...hasModifed, activePage]);
  }

  const accrualMethod = Form.useWatch("accrualMethod", form);

  React.useEffect(() => {
    form.setFieldsValue(data);
    !data.discountRate && form.setFieldValue("discountRate", 0);
  }, [data]);

  React.useEffect(() => {
    form.setFieldsValue({
      interestRateSource:
        template.rateSourceOptions.find((item) => item.value === 527)?.value ?? null,
      interestCalculationBasis:
        template.interestCalculationBasisOptions.find((item) => item.value === 2)?.value ?? null,
      accrualMethod: template.accrualMethodOptions.find((item) => item.value === 2)?.value ?? null,
    });
  }, []);

  console.log(template);
  return (
    <SectionCard onPrev={goBack} onNext={form.submit} nextTitle={"Next - Maturity Settings"}>
      <Form
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        style={{ paddingTop: 0 }}
        onValuesChange={handleValuesChange}
      >
        <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
          Price and Rate Settings
        </Title>

        <Space style={{ paddingTop: 40 }} />
        <Row style={{ marginTop: 20 }} gutter={16}>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              // style={{ marginTop: 20 }}
              label={
                <Text style={{ color: "#344054" }}>
                  Pricing Method <InfoCircleOutlined color="#667085" />
                </Text>
              }
              name="pricingMethod"
              rules={[
                {
                  required: true,
                  message: "Please select pricing method",
                },
              ]}
            >
              <Select
                // size="large"
                options={template?.pricingMethods}
                placeholder={"Discount yield based"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              // style={{ marginTop: 20 }}
              name="pricingFrequency"
              rules={[
                {
                  required: true,
                  message: "Please select pricing Frequency",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Pricing Frequency <InfoCircleOutlined color="#667085" />
                </Text>
              }
            >
              <Select
                // size="large"
                options={template?.pricingFrequencies}
                placeholder={"Per auction"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              name="discountRate"
              rules={[
                // { min: 1, message: "Discount rate cannot be less than 1" },
                {
                  required: true,
                  message: "Please enter discount rate",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Discount Rate <InfoCircleOutlined color="#667085" />
                </Text>
              }
            >
              <Input
                addonAfter={<div>%</div>}
                className="custom-input"
                // size="large"
                placeholder="10"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              // style={{ marginTop: 20 }}
              name="interestRateSource"
              rules={[
                {
                  required: true,
                  message: "Please select discount rate source",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Discount Rate Source <InfoCircleOutlined color="#667085" />
                </Text>
              }
            >
              <Select
                // size="large"
                options={template?.rateSourceOptions}
                placeholder={"Select discount rate source"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              name="interestCalculationBasis"
              rules={[
                {
                  required: true,
                  message: "Please select interest rate basis",
                },
              ]}
              // style={{ marginTop: 20 }}
              label={
                <Text style={{ color: "#344054" }}>
                  Discount Rate Basis <InfoCircleOutlined color="#667085" />
                </Text>
              }
            >
              <Select
                // size="large"
                options={template?.interestCalculationBasisOptions}
                placeholder={"Select interest rate basis"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              name="accrualMethod"
              rules={[
                {
                  required: true,
                  message: "Please select accrual method",
                },
              ]}
              // style={{ marginTop: 20 }}
              label={
                <Text style={{ color: "#344054" }}>
                  Accrual Method <InfoCircleOutlined color="#667085" />
                </Text>
              }
            >
              <Select
                // disabled
                defaultActiveFirstOption
                // defaultValue={2}
                // size="large"
                options={template?.accrualMethodOptions}
                placeholder={"Select accrual method"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
        </Row>
        {typeof accrualMethod == "number" && <RenderFormula accrualMethod={accrualMethod} />}
      </Form>
    </SectionCard>
  );
}

const RenderFormula = ({ accrualMethod }) => {
  return (
    <div
      style={{
        lineHeight: "1.6",
        backgroundColor: "#F9FAFB",
        borderRadius: 20,
        paddingInline: 20,
        paddingBlock: 10,
        fontSize: 18,
      }}
    >
      {accrualMethod === 2 && (
        <>
          <h5>
            For each day <i>t</i> :{" "}
          </h5>
          <p
            style={{
              display: "flex",
              gap: 5,
              alignItems: "center",
              fontSize: 14,
              textAlign: "center",
            }}
          >
            <span>
              Accured Interest <sub>t</sub>
            </span>
            <span style={{ fontSize: 10 }}> =</span>
            <span>
              Book Value <sub>t-1</sub>
            </span>
            × (Effective Interest Rate (EIR) / Days In Year)
          </p>
          <p
            style={{
              display: "flex",
              gap: 5,
              alignItems: "center",
              fontSize: 14,
              textAlign: "center",
            }}
          >
            <span>
              Book Value <sub>t</sub>
            </span>
            <span style={{ fontSize: 10 }}> =</span>
            <span>
              Book Value <sub>t-1</sub>
            </span>
            +{" "}
            <span>
              Accrued Interest <sub>t</sub>
            </span>
          </p>
          <h5>Where : </h5>
          <ul
            style={{
              display: "grid",
              gridTemplateColumns: "10px auto",
              gap: 10,
              paddingInline: 0,
              alignItems: "center",
              fontSize: 13,
              color: "#667085",
            }}
          >
            <span
              style={{
                backgroundColor: "#BA24D5",
                width: "10px",
                height: "10px",
                borderRadius: 9999,
              }}
            />
            <span>
              <b>
                Book Value <sub>t</sub>
              </b>{" "}
              is the carrying amount of the T-Bill at time <i>t</i>
            </span>
            <span
              style={{
                backgroundColor: "#BA24D5",
                width: "10px",
                height: "10px",
                borderRadius: 9999,
              }}
            />
            <span>
              <b>EIR</b> is the annualized effective yield calculated from the discount and tenor
            </span>
            <span
              style={{
                backgroundColor: "#BA24D5",
                width: "10px",
                height: "10px",
                borderRadius: 9999,
              }}
            />
            <span>
              <b>Days In Year</b> is typically 365 or 360 (depending on day count convention)
            </span>
            <span
              style={{
                backgroundColor: "#BA24D5",
                width: "10px",
                height: "10px",
                borderRadius: 9999,
              }}
            />
            <span>
              The <b>Face Value</b> is reached at maturity
            </span>
          </ul>
        </>
      )}
      {accrualMethod === 0 && (
        <>
          <ul
            style={{
              display: "grid",
              gridTemplateColumns: "10px auto",
              gap: 10,
              paddingInline: 0,
              alignItems: "center",
              fontSize: 13,
              color: "#667085",
            }}
          >
            <span
              style={{
                backgroundColor: "#BA24D5",
                width: "10px",
                height: "10px",
                borderRadius: 9999,
              }}
            />
            <span>
              Accrues the discount <b>equally over the tenor</b> of the instrument
            </span>
            <span
              style={{
                backgroundColor: "#BA24D5",
                width: "10px",
                height: "10px",
                borderRadius: 9999,
              }}
            />
            <span>Simple and common in accounting systems</span>
          </ul>
          <h5>Formula : </h5>
          <div
            style={{
              display: "flex",
              gap: 10,
              paddingInline: 0,
              alignItems: "center",
              fontSize: 14,
            }}
          >
            <span>Daily Accrual</span>
            <span style={{ fontSize: 12 }}>=</span>
            <span style={{ textAlign: "center" }}>
              <span>Discount</span>
              <hr style={{ border: "1px solid rgba(102, 112, 133, 0.15)" }} />
              <span>Tenor(days)</span>
            </span>
          </div>
          <div>
            <h5>Use case : </h5>
            <p style={{ fontSize: 14 }}>Simpler systems, financial reporting</p>
          </div>
        </>
      )}
    </div>
  );
};
